import React, { useState } from 'react';
import { Grid, Typography, Box } from '@material-ui/core';
import { Header, Publication } from './components';
import expData from './components/Publication/PublicationsData';
import uuid from 'uuid/v1';
import Grow from '@material-ui/core/Grow';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';


function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    width: '100%'
  },
  content: {
    marginTop: '1%',
    [theme.breakpoints.up('xs')]: {
      padding: '3% 7% 0% 7%'
    },
    [theme.breakpoints.down('xs')]: {
      padding: '16% 10% 0% 10%'
    },
  },
  padding: {
    padding: theme.spacing(3)
  },
  demo1: {
    backgroundColor: theme.palette.background.paper,
    paddingTop: '5vh'
  },
}));

const Publications = () => {
  window.scrollTo(0, 0)
  const classes = useStyles();
  const [publications] = useState(expData);

  return (
    <div className={classes.root}>
      <Header />
      <div className={classes.content}>
        <Grid
          container
          spacing={3}
        >
          {publications.map(publication => {
            return (
              <Grow in={true} key={uuid()}>
                <Grid
                  item
                  key={uuid()}
                  xl={3}
                  lg={4}
                  md={6}
                  sm={6}
                  xs={12}
                >
                  <Publication publication={publication} />
                </Grid>
              </Grow>
            )
          })}
        </Grid>
      </div>
    </div>
  );
};

export default Publications;